import store from '../../global-state/redux';
import { fetchUserComplete } from './actions';

const { dispatch } = store;

export const reloadUserComplete = (props) => {
  dispatch(fetchUserComplete(props));
};
